import React, { useEffect, useState } from "react";
import "./App.css";
import Header from "./components/features/peruquiosco/Header/default";
import Footer from "./components/features/peruquiosco/Footer/default";
import Carousel from "./components/features/peruquiosco/Carousel/default";
import Content from "./components/features/peruquiosco/Content/default";
import SliderCovers from "./components/features/peruquiosco/Covers/default";
import ScrollUp from "./components/features/peruquiosco/_children/ScrollUp/ScrollUp";
import useScript from "./hooks/useScript";
import configPiano from "./piano/config";
// import { Route } from "wouter";
import DataTreatment from "pages/DataTreatment";

function App() {
  useScript(
    process.env.REACT_APP_ENV === "PROD"
      ? `https://experience.piano.io/xbuilder/experience/load?aid=${process.env.REACT_APP_PIANO_AID}`
      : `https://sandbox.piano.io/xbuilder/experience/load?aid=${process.env.REACT_APP_PIANO_AID}`
  );
  configPiano(process.env.REACT_APP_PIANO_AID, handlerLoginSuccess);

  const [userData, setUserData] = useState({
    user: {},
    logged: false,
    token: "",
  });

  const [pageView, setPageView] = useState("home");

  function handlerLoginSuccess(data: any) {
    setUserData({
      ...userData,
      user: data,
      logged: true,
      token: window?.tp?.pianoId.getToken(),
    });
  }

  useEffect(() => {
    setTimeout(() => {
      if (window.tp?.pianoId.getUser() != null)
        setUserData({
          ...userData,
          logged: true,
          user: window?.tp?.pianoId.getUser(),
          token: window?.tp?.pianoId.getToken(),
        });

      const search = window.location.search;
      const params = new URLSearchParams(search);
      const action = params.get("action");

      if (action === "logout") {
        window.tp.pianoId.logout();
        setTimeout(() => {
          window.location.href = "/";
        }, 500);
      }
    }, 750);
  }, []);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const pageParam = params.get("page");

    if (pageParam === "tratamiento-datos") {
      setPageView("tratamiento-datos");
    }
  }, []);

  return (
    <div className="App">
      {pageView === "home" ? (
        <>
          <Header user={userData} setUser={setUserData} />
          <div id="home" />
          <Carousel />
          <SliderCovers user={userData} />
          <div id="subscriptions" />
          <Content />
          <Footer />
          <ScrollUp />
        </>
      ) : (
        <>
          <Header user={userData} setUser={setUserData} />
          <DataTreatment />
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
